import { createRouter, createWebHistory } from "vue-router";
import AlertBoxView from "../views/AlertBoxView.vue";

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      // sceneId optional so "/" resolves here too (no bogus "missing-scene-id"
      // redirect). AlertBoxView shows a "Scene not found" message when absent.
      path: "/:sceneId?",
      name: "alerts",
      component: AlertBoxView,
    },
  ],
});

export default router;
